/**
 * Shim für expo/dom (fehlt in Expo SDK 49 bei Webpack-Web-Build).
 * expo-router erwartet IS_DOM; auf Web ist das true.
 * CommonJS, damit Babel-Loader keine Probleme macht.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_DOM = void 0;
exports.IS_DOM = true;
